import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionVarianceReport } from './Pages';

export const LeafCollectionVarianceDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafCollectionVarianceReport} />
    </Fragment>
)